import { type FederatedSeller, useSellerData } from '@fiverr-private/seller_pages_toolbox';

export const useSellerId = () => {
    const { sellerId } = useSellerData(selectSellerSlice);

    return sellerId;
};

const selectSellerSlice = (seller: FederatedSeller) => ({
    sellerId: seller.user.id,
});
